import React from "react";
import bannerImage from '../assets/images/banner.png';
import './ContactUs.css';

const ContactUs = () => {
    return (
        <>
            <div className=' home-container1'>
                <div
                    className="banner-section"
                    style={{ backgroundImage: `url(${bannerImage})` }}
                >
                    <div className="banner-overlay"></div>
                    <div className="banner-content">
                        <h1>Contact</h1>
                        <p className="breadcrumb-text">
                            <span>Home</span> <span className="arrow">&rarr;</span> <span>Contact</span>

                        </p>
                    </div>
                </div>
            </div>
             <section className="contact-info">
        <h2 className="section-title">Our Contact Information</h2>
        <div className="info-grid">
          <div className="info-card">
            <i className="fas fa-map-marker-alt"></i>
            <h4>Our Address</h4>
            <p>WeWork Krishe Emerald, Kondapur, Hyderabad, Telangana 500084</p>
          </div>
          <div className="info-card">
            <i className="fas fa-phone"></i>
            <h4>Phone Number</h4>
            <p>
              +91 9908173249 <br /> +91 9963700363
            </p>
          </div>
          <div className="info-card">
            <i className="fas fa-envelope"></i>
            <h4>Email Address</h4>
            <p>
              contact@plotsverified.com <br /> support@plotsverified.com
            </p>
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="contact-form-map">
        <div className="form-box">
          <h2>Schedule a Visit</h2>
          <form>
            <input type="text" placeholder="Your Name*" required />
            <input type="email" placeholder="Your Email*" required />
            <select>
              <option>Real Estate</option>
              <option>Land Inquiry</option>
              <option>Support</option>
            </select>
            <textarea placeholder="Type Your Message"></textarea>
            <button type="submit">Submit Message ➤</button>
          </form>
        </div>
        <div className="map-box">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.527093562396!2d78.36578501487671!3d17.448293605602834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e8f6f06a27%3A0x6f0f03d737bbb45b!2sWeWork%20Krishe%20Emerald%2C%20Kondapur%2C%20Hyderabad%2C%20Telangana%20500084!5e0!3m2!1sen!2sin!4v1690000000000"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>
        </>
    );

};

export default ContactUs